import createVueComponent from '../createVueComponent';

const Activity = createVueComponent('ActivityIcon', [
  ['path', { d: 'M22 12h-4l-3 9L9 3l-3 9H2', key: 'd5dnw9' }],
]);

export default Activity;
